import { Buttons } from '@koob/margaret';
import { KoobButton } from '@koob/ui';
import { Modal } from 'components';
import { Warning } from 'ui';

export const KoobConfirmationModal = ({
  handleCancel,
  handleSubmit,
  isSubmitting,
  description,
  translation,
  modalIsShown,
  title,
}) => {
  return (
    <Modal
      contentHasOwnScrollbars
      onRequestClose={() => {
        handleCancel();
      }}
      isOpen={modalIsShown}
      title={title ?? translation('misc:warning')}
      footer={
        <Buttons alignX="center">
          <KoobButton
            type="button"
            onClick={() => {
              handleCancel();
            }}
            variant="secondary"
          >
            {translation('misc:cancel')}
          </KoobButton>
          {handleSubmit && (
            <KoobButton
              variant="primary"
              type="submit"
              onClick={handleSubmit}
              loading={isSubmitting}
              testId={'confirm-delete'}
            >
              {translation('misc:continue')}
            </KoobButton>
          )}
        </Buttons>
      }
    >
      <Warning>{description}</Warning>
    </Modal>
  );
};
